<template>
  <div class="card card-custom gutter-b">
    <!--begin::Header-->
    <div class="card-header border-0 py-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label font-weight-bolder text-dark">{{ $t('TRANSLATOR.LINES', { msg: 'LINES' }) }}</span>
        <span class="text-muted mt-3 font-weight-bold font-size-sm"></span>
      </h3>
      <!-- <div class="card-toolbar">
        <a href="#" class="btn btn-info font-weight-bolder font-size-sm"
          >New Report</a
        >
      </div> -->
    </div>
    <!--end::Header-->
    <!--begin::Body-->
    <div class="card-body py-0">
      <!--begin::Table-->
      <div class="table-responsive">
        <table class="table table-head-custom table-vertical-center" id="kt_advance_table_widget_4">
          <thead>
            <tr class="text-left">
              <th style="width: 200px;">{{ $t("TRANSLATOR.LINEID", { msg: "LINEID" }) }}</th>
              <th class="pl-0" style="width: 300px;">{{ $t('TRANSLATOR.STATUS', { msg: 'STATUS' }) }}</th>
              <th class="text-right" style="min-width: 60px; max-width: 100px">{{ $t('TRANSLATOR.TOTAL', { msg: 'TOTAL' }) }} {{ $t('TRANSLATOR.CONVEYOR', { msg: 'CONVEYOR' }) }}</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item, i) in lines">
              <tr v-bind:key="i">
                <td>
                  <a v-bind:href="`#/line/${item.lineNumber}`" class="text-dark-75 font-weight-bolder text-hover-primary font-size-lg" >
                    <!-- {{ item.lineName }} -->
                    {{ $t('TRANSLATOR.LINE', { msg: 'LINE' }) }} {{ item.lineNumber }}
                  </a>
                </td>
                <td class="pl-0">
                  <!-- <span v-if="item.statusRed === 0 && item.statusOrange === 0"  class="label label-lg label-inline label-light-success">
                    <span class="svg-icon">
                      <inline-svg src="media/svg/icons/Navigation/Check.svg" />
                    </span>
                  </span>
                  <span v-if="item.statusRed === 0 && item.statusOrange > 0"  class="label label-lg label-inline label-light-warning">
                    <span class="svg-icon">
                      <inline-svg src="media/svg/icons/Code/warning-1-circle.svg" />
                    </span>
                  </span>
                  <span v-if="item.statusRed > 0"  class="label label-lg label-inline label-light-danger">
                    <span class="svg-icon">
                      <inline-svg src="media/svg/icons/Code/Warning-2.svg" />
                    </span>
                  </span> -->
                  <b-progress :max="item.statusGreen + item.statusOrange + item.statusRed" show-value>
                    <b-progress-bar :value="item.statusGreen" variant="success"></b-progress-bar>
                    <b-progress-bar :value="item.statusOrange" variant="warning"></b-progress-bar>
                    <b-progress-bar :value="item.statusRed" variant="danger"></b-progress-bar>
                  </b-progress>
                </td>
                <td class="text-right">
                  <span class="text-dark-75 font-weight-bolder d-block font-size-lg">
                    <!-- {{ item.company_desc }} -->
                  </span>
                  <span class="text-muted font-weight-bold">{{item.conveyorQty}}</span>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <!--end::Table-->
      <div class="row" v-if="loading">
        <div class="col-md-12">
          <div class="text-center">
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
          </div>
        </div>
      </div>
    </div>
    <!--end::Body-->
  </div>
</template>

<script>
export default {
  name: "widget-1",
  props: ['lines','loading'],
  data() {
    return {
      checked: false,
    };
  },
  computed: {
    getTotalOrange() {
      const total = 15
      return total;
    },
    getTotalRed() {
      const total = 5
      return total;
    },
    getTotalGreen() {
      const total = this.lines.reduce((sum, object) => {
        sum += object.statusGreen;
        return sum;
      }, 0);
      return total;
    },
  },
  components: {},
  methods: {
    getStatusClass: (status) => {
      switch(status) {
        case 'red': return 'danger';
        case 'orange': return 'warning';
        case 'green': return 'success';
      }
    }
  }
};
</script>
